import { Component, inject, Input } from '@angular/core';
import { BillerInterface } from '@tae/interfaces';
import { PictureBasicCardEnum } from 'src/app/enums/basic-card.enum';
import { PictureBasicCardInterface } from 'src/app/interfaces/basic-card.interface';
import { CtrlRechargeService } from 'src/app/services/ctrl-recharge/ctrl-recharge.service';

@Component({
    selector: 'app-telephone-companies',
    templateUrl: './telephone-companies.component.html',
    styleUrls: ['./telephone-companies.component.scss'],
    standalone: false
})
export class TelephoneCompaniesComponent {
  /**
   *  Valor del titulo de la card
   */
  @Input({ required: true }) title: string;

  @Input({ required: true }) viewSkeleton: boolean;

  @Input() company: BillerInterface;

  private ctrlRecharge = inject(CtrlRechargeService);

  public get nameBiller() {
    if (this.company) {
      const { name } = this.company;
      return name;
    }
    return 'Selecciona la compañía';
  }

  public get picture(): PictureBasicCardInterface {
    return this.ctrlRecharge.getPicture(this.company?.billerId || '');
  }
}
